import { useEffect, useState } from "react";

type SidebarStateOptions = {
  defaultCollapsed?: boolean;
  defaultPinned?: boolean;
  collapsedKey?: string;
  pinnedKey?: string;
};

export function useWorkspaceSidebarState({
  defaultCollapsed = false,
  defaultPinned = true,
  collapsedKey = "xlflow.sidebarCollapsed",
  pinnedKey = "xlflow.sidebarPinned",
}: SidebarStateOptions = {}) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);
  const [pinned, setPinned] = useState(defaultPinned);

  useEffect(() => {
    const storedCollapsed = window.localStorage.getItem(collapsedKey);
    const storedPinned = window.localStorage.getItem(pinnedKey);
    if (storedCollapsed !== null) setCollapsed(storedCollapsed === "true");
    if (storedPinned !== null) setPinned(storedPinned === "true");
  }, [collapsedKey, pinnedKey]);

  useEffect(() => {
    window.localStorage.setItem(collapsedKey, String(collapsed));
  }, [collapsed, collapsedKey]);

  useEffect(() => {
    window.localStorage.setItem(pinnedKey, String(pinned));
  }, [pinned, pinnedKey]);

  useEffect(() => {
    if (pinned) setCollapsed(false);
  }, [pinned]);

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      if (next && pinned) setPinned(false);
      return next;
    });
  };

  const togglePinned = () => {
    setPinned((prev) => {
      const next = !prev;
      if (!next) {
        setCollapsed(true);
      }
      return next;
    });
  };

  return {
    collapsed,
    pinned,
    setCollapsed,
    setPinned,
    toggleCollapsed,
    togglePinned,
  };
}
